angular.module('eStories.communicationSettings', [
    'eStories.account.model'
])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.communicationSettings', {
                url: 'communicationSettings',
                views: {
                    'mainView@': {
                        templateUrl: '/account/communicationSettings/communicationSettings.tmpl.html',
                        controller: 'UpdateEmailOptionsCtrl',
                        controllerAs: 'updateEmailOptionsCtrl'
                    }
                }
            });
    }])

    .controller('EmailPreferencesIdentificationCtrl', [
        'AccountModel',
        'ModalsModel',
        'ValidationModel',
        '$location',
        '$uibModalInstance',
        '$rootScope',
        'GA',
        function (AccountModel, ModalsModel, ValidationModel, $location, $uibModalInstance, $rootScope, GA) {
            var emailPreferencesIdentificationCtrl = this;

            GA.trackPageView($location.path());

            emailPreferencesIdentificationCtrl.formErrors = {};

            emailPreferencesIdentificationCtrl.freeOfErrors = function () {
                var obj = emailPreferencesIdentificationCtrl.formErrors;
                return Object.keys(obj).length === 0 && JSON.stringify(obj) === JSON.stringify({});
            };

            emailPreferencesIdentificationCtrl.validateEmail = function (email) {
                return ValidationModel.validateEmail(email, emailPreferencesIdentificationCtrl.formErrors);
            };

            emailPreferencesIdentificationCtrl.submitIdentification = function () {
                $uibModalInstance.close();
                $location.path('/communicationSettings').search({email: emailPreferencesIdentificationCtrl.email});
                $rootScope.$broadcast('communicationSettingsIdentificationMade');
            };
        }])

    .controller('UpdateEmailOptionsCtrl', [
        'AccountModel',
        'ModalsModel',
        '$location',
        '$scope',
        function (AccountModel, ModalsModel, $location, $scope) {

            var updateEmailOptionsCtrl = this;

            updateEmailOptionsCtrl.attemptToGetEmailPreferences = async function () {
                var urlParamsObj = $location.search();
                var snid = urlParamsObj["snid"];
                var email = urlParamsObj["email"];
                if (!updateEmailOptionsCtrl.modalOpen && (snid == null || snid == "") && (email == null || email == "")) {
                    updateEmailOptionsCtrl.modalOpen = true;
                    ModalsModel.open('account/communicationSettings/emailPreferencesIdentificationModal.tmpl.html', 'EmailPreferencesIdentificationCtrl', 'emailPreferencesIdentificationCtrl');
                }

                const response = await AccountModel.getUserEmailPreferences(snid);
                try {
                    if (response && response.responseStatus === "SUCCESS") {
                        updateEmailOptionsCtrl.optInToMarketingEmails = response.optInToMarketingEmails;
                        updateEmailOptionsCtrl.offerOptInEmails = response.offerOptInEmails;
                        updateEmailOptionsCtrl.contentOptInEmails = response.contentOptInEmails;
                        updateEmailOptionsCtrl.productOptInEmails = response.productOptInEmails;
                    }
                } catch (error) {
                    updateEmailOptionsCtrl.serverError = 'Internal Error (' + error.responseText + ')';
                }
            };

            if (AccountModel.userDetails) {
                updateEmailOptionsCtrl.optInToMarketingEmails = AccountModel.userDetails.optInToMarketingEmails ? true : false;
                updateEmailOptionsCtrl.offerOptInEmails = AccountModel.userDetails.offerOptInEmails ? true : false;
                updateEmailOptionsCtrl.contentOptInEmails = AccountModel.userDetails.contentOptInEmails ? true : false;
                updateEmailOptionsCtrl.productOptInEmails = AccountModel.userDetails.productOptInEmails ? true : false;
            } else {
//                console.log("need to know user's current preferences from server bc they're not logged in here...")
                updateEmailOptionsCtrl.attemptToGetEmailPreferences();
            }
            updateEmailOptionsCtrl.serverError = null;

            $scope.$on("communicationSettingsIdentificationMade", function () {
                updateEmailOptionsCtrl.attemptToGetEmailPreferences();
            });

            updateEmailOptionsCtrl.doNotSendEmailsClicked = function () {
                updateEmailOptionsCtrl.optInToMarketingEmails = !updateEmailOptionsCtrl.optInToMarketingEmails;
                updateEmailOptionsCtrl.offerOptInEmails = updateEmailOptionsCtrl.optInToMarketingEmails;
                updateEmailOptionsCtrl.contentOptInEmails = updateEmailOptionsCtrl.optInToMarketingEmails;
                updateEmailOptionsCtrl.productOptInEmails = updateEmailOptionsCtrl.optInToMarketingEmails;
            };

            updateEmailOptionsCtrl.productOptInEmailClicked = function () {
                updateEmailOptionsCtrl.productOptInEmails = !updateEmailOptionsCtrl.productOptInEmails;
                if (updateEmailOptionsCtrl.productOptInEmails && !updateEmailOptionsCtrl.optInToMarketingEmails) {
                    updateEmailOptionsCtrl.optInToMarketingEmails = true;
                }
                if (!updateEmailOptionsCtrl.offerOptInEmails &&
                    !updateEmailOptionsCtrl.contentOptInEmails &&
                    !updateEmailOptionsCtrl.productOptInEmails) {
                    updateEmailOptionsCtrl.optInToMarketingEmails = false;
                }
            };
            updateEmailOptionsCtrl.contentOptInEmailClicked = function () {
                updateEmailOptionsCtrl.contentOptInEmails = !updateEmailOptionsCtrl.contentOptInEmails;
                if (updateEmailOptionsCtrl.contentOptInEmails && !updateEmailOptionsCtrl.optInToMarketingEmails) {
                    updateEmailOptionsCtrl.optInToMarketingEmails = true;
                }
                if (!updateEmailOptionsCtrl.offerOptInEmails &&
                    !updateEmailOptionsCtrl.contentOptInEmails &&
                    !updateEmailOptionsCtrl.productOptInEmails) {
                    updateEmailOptionsCtrl.optInToMarketingEmails = false;
                }
            };
            updateEmailOptionsCtrl.offerOptInEmailClicked = function () {
                updateEmailOptionsCtrl.offerOptInEmails = !updateEmailOptionsCtrl.offerOptInEmails;
                if (updateEmailOptionsCtrl.offerOptInEmails && !updateEmailOptionsCtrl.optInToMarketingEmails) {
                    updateEmailOptionsCtrl.optInToMarketingEmails = true;
                }
                if (!updateEmailOptionsCtrl.offerOptInEmails &&
                    !updateEmailOptionsCtrl.contentOptInEmails &&
                    !updateEmailOptionsCtrl.productOptInEmails) {
                    updateEmailOptionsCtrl.optInToMarketingEmails = false;
                }
            };

            updateEmailOptionsCtrl.submitEmailOptions = async function () {
                updateEmailOptionsCtrl.serverError = null;
                updateEmailOptionsCtrl.setInProgressFlag(true);
                var emailOptionsObj = {
                    optInToMarketingEmails: updateEmailOptionsCtrl.optInToMarketingEmails,
                    offerOptInEmails: updateEmailOptionsCtrl.offerOptInEmails,
                    contentOptInEmails: updateEmailOptionsCtrl.contentOptInEmails,
                    productOptInEmails: updateEmailOptionsCtrl.productOptInEmails
                };
//                look for snid in url param or inside AccountModel.user
                updateEmailOptionsCtrl.urlParams = $location.search()
                if (AccountModel.userDetails) {
//                    get snid from userDetails
                    emailOptionsObj.snid = AccountModel.userDetails.snid;
                } else {
//                    get snid from url location
                    emailOptionsObj.snid = updateEmailOptionsCtrl.urlParams["snid"]
                }

                if (emailOptionsObj.snid == null || emailOptionsObj.snid == "") {
                    emailOptionsObj.snid = null;
                    emailOptionsObj.email = updateEmailOptionsCtrl.urlParams["email"];
                }

                const response = await AccountModel.updateUserEmailPreferences(emailOptionsObj);
                if (response != null && response.responseStatus === 'SUCCESS') {
                    if (AccountModel.userDetails != null) {
                        AccountModel.userDetails.optInToMarketingEmails = updateEmailOptionsCtrl.optInToMarketingEmails;
                        AccountModel.userDetails.offerOptInEmails = updateEmailOptionsCtrl.offerOptInEmails;
                        AccountModel.userDetails.contentOptInEmails = updateEmailOptionsCtrl.contentOptInEmails;
                        AccountModel.userDetails.productOptInEmails = updateEmailOptionsCtrl.productOptInEmails;
                    }
                    ModalsModel.open('account/communicationSettings/updateEmailPreferencesSuccessModal.tmpl.html', 'AccountCtrl', 'accountCtrl');
                    updateEmailOptionsCtrl.updateEmailOptionsInProgress = false;
                } else {
                    updateEmailOptionsCtrl.setInProgressFlag(false);
                    updateEmailOptionsCtrl.serverError = 'Internal Error (' + response.responseText + ')';
                }
            };

            updateEmailOptionsCtrl.setInProgressFlag = function (inProgress) {
                updateEmailOptionsCtrl.updateEmailOptionsInProgress = inProgress;
            };
        }]);
